import type { FC, PropsWithChildren } from 'react';

import ExploreBackground from '@/components/_explore/ExploreBackground.tsx';
import RegisteredWrapper from '@/components/RegisteredWrapper.tsx';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

import Footer from '../Footer.tsx';
import Header from '../Header/index.tsx';

type MapLayoutProps = {
  title: TranslationKey;
};
const MapLayout: FC<PropsWithChildren<MapLayoutProps>> = ({ title, children }) => {
  useTitle(title);

  return (
    <div className="vh-100 d-flex flex-column ">
      <Header />
      <div className="position-relative flex-grow-1">
        <ExploreBackground />
        <RegisteredWrapper>{children}</RegisteredWrapper>
      </div>
      <div className="flex-grow-0">
        <Footer />
      </div>
    </div>
  );
};

export default MapLayout;
